export function mcpConnectionTest(serverUrl: string) {
  return {
    protocol: "http" as const,
    request: () => ({
      url: serverUrl,
      method: "POST" as const,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json, text/event-stream",
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: 1,
        method: "initialize",
        params: {
          protocolVersion: "2025-06-18",
          capabilities: {},
          clientInfo: { name: "3B", version: "1.0" },
        },
      }),
      expectedBodyContains: "jsonrpc",
    }),
  };
}
